import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HumanizePipe } from './humanize.pipe';
import { TextNormalizePipe } from './text-normalize.pipe';

@NgModule({
  declarations: [
    HumanizePipe,
    TextNormalizePipe
  ],
  exports: [
    HumanizePipe,
    TextNormalizePipe
  ],
  imports: [
    CommonModule,
  ]
})
export class PipesModule { }
